import axios from "axios";
const defaultIpInfo = {
    ip: "0.0.0.0",
    country: "ES",
    cityName: "Barcelona",
};
let reachedIpAPILimit = false;
async function getIPInfoFromIPApi() {
    const response = await axios.get("https://pro.ip-api.com/json?key=lUmvbRM5SgMxJ6h");
    reachedIpAPILimit = response.headers["X-Rl"] === 0;
    return {
        ip: response.data.query,
        country: response.data.countryCode,
        cityName: response.data.city,
    };
}
async function getIPInfoFromExtremeIP() {
    const response = await axios.get("https://extreme-ip-lookup.com/json/");
    return {
        ip: response.data.query,
        country: response.data.countryCode,
        cityName: response.data.city,
    };
}
export async function getIPInfo() {
    if (!reachedIpAPILimit) {
        try {
            return await getIPInfoFromIPApi();
        }
        catch (e) {
            // failed because of reasons or api limit
        }
    }
    try {
        return await getIPInfoFromExtremeIP();
    }
    catch (e) {
        // failed because of reasons or api limit
        return defaultIpInfo;
    }
}
